import { render, staticRenderFns } from "./Adminer.vue?vue&type=template&id=5b9ce97a&scoped=true&"
import script from "./Adminer.vue?vue&type=script&lang=js&"
export * from "./Adminer.vue?vue&type=script&lang=js&"
import style0 from "./Adminer.vue?vue&type=style&index=0&id=5b9ce97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ce97a",
  null
  
)

export default component.exports